import { compose, color, space, ColorProps, SpaceProps } from 'styled-system';

const COMMON = compose(color, space);

export interface CommonStyle extends ColorProps, SpaceProps {}

export default COMMON;
